import { Box, chakra, HTMLChakraProps } from "@chakra-ui/react";
import { PropsWithChildren } from "react";

/*
 * A note on this component:
 * Evergreen supplies an isActive property to their standard button, however their use of :active
 * and :focus pseudo-selectors for styling does not work consistently on mobile. For that reason we
 * had to re-implement the functionality in this special toggle button component.
 */

interface ToggleButtonProps
  extends PropsWithChildren<HTMLChakraProps<"button">> {
  isActive?: boolean;
}

export const ToggleButton = ({
  isActive,
  children,
  ...props
}: ToggleButtonProps) => {
  return (
    <chakra.button
      type="button"
      data-active={isActive ? "" : undefined}
      height="45px"
      borderWidth="2px"
      borderColor="brand.green.dark"
      borderStyle="solid"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      cursor="pointer"
      borderRadius="0.3125rem"
      background="white"
      paddingX="1rem"
      position="relative"
      color="brand.green.dark"
      _hover={{ backgroundColor: "brand.neutral.medium" }}
      css={{
        "&[data-active]": {
          backgroundColor: "var(--chakra-colors-brand-green-light)",
          fontWeight: "bold",
        },
        "& > .bold-spacer": {
          fontWeight: "bold",
          visibility: "hidden",
          height: 0,
          whiteSpace: "nowrap",
        },
      }}
      {...props}
    >
      <Box className="text">{children}</Box>
      <Box className="bold-spacer">{children}</Box>
    </chakra.button>
  );
};
